import { RequestStatus } from './Enums';

export const VTO_TYPES = [
    { value: 0, label: 'Single day', translation: 'singleDay', checked: false },
    { value: 1, label: 'Block of days', translation: 'blockOfDays', checked: false },
    { value: 2, label: 'Time period', translation: 'timePeriod', checked: false }
]

export const MULTI_PARTIAL_PER_SHIFT = 2;

export const ongoingRequestStatuses = [
    RequestStatus.Offered,
    RequestStatus.Pending,
    RequestStatus.Submitted,
];

export const ongoingProposalStatuses = [
    RequestStatus.Pending,
    RequestStatus.Submitted,
];

export const EXCLUDED_HYPERFIND_IDS = [-13, -10, -9, -6, -4, -3, -2, 1];

export const REQUEST_PAGE_DEFAULT_HYPERFIND = Object.freeze({
    value: null,
    label: "None",
    desc: "",
    visibility: true,
});

export const REQUEST_PAGE_DEFAULT_SELECTED_STATUS = [
    { label: "Approved", value: 2 },
    { label: "Pending", value: 7 },
    { label: "Refused", value: 3 }, 
    { label: "Submitted", value: 1 }, 
    { label: "Retracted", value: 10 }];

export const WARNING_TYPES = {
    FAILING_HYPERFIND_EXECUTION: "IsFailingHyperfindExecution"
};